import { hashtgaPosts } from "assets/data/posts";
import { MarkFeedPost } from "components";

const HashtagPosts = () => {
    return (
        <>
            {hashtgaPosts.map((i) => (
                <MarkFeedPost post={{ ...i, hashtag: "name1" }} key={i.id} />
            ))}
        </>
    );
};

export default HashtagPosts;
